import React from 'react';

const SvgError: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    viewBox="-4 -4 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.87845 0.630523C5.85261 0.209973 6.89305 0 7.99861 0C9.10416 0 10.1448 0.20988 11.1194 0.630239C12.0918 1.04966
      12.9388 1.61942 13.6593 2.33962C14.3798 3.05983 14.9499 3.90645 15.3695 4.87845C15.79 5.85261 16 6.89305 16 7.99861C16
      9.10416 15.7901 10.1448 15.3698 11.1194C14.9503 12.0918 14.3806 12.9388 13.6604 13.6593C12.9402 14.3798 12.0935 14.9499
      11.1216 15.3695C10.1474 15.79 9.10695 16 8.00139 16C6.89584 16 5.8552 15.7901 4.88062 15.3698C3.9082 14.9503 3.06122
      14.3806 2.34069 13.6604C1.62015 12.9402 1.05013 12.0935 0.630523 11.1216C0.209972 10.1474 0 9.10695 0 8.00139C0 6.89584
      0.209879 5.8552 0.630238 4.88062C1.04966 3.9082 1.61941 3.06122 2.33962 2.34069C3.05983 1.62015 3.90645 1.05013 4.87845
      0.630523ZM8 1.4707C6.17503 1.4707 4.63333 2.10271 3.36802 3.36802C2.10271 4.63333 1.4707 6.17503 1.4707 8C1.4707 9.82497
      2.10271 11.3667 3.36802 12.632C4.63333 13.8973 6.17503 14.5293 8 14.5293C9.82496 14.5293 11.3667 13.8973 12.632
      12.632C13.8973 11.3667 14.5293 9.82497 14.5293 8C14.5293 6.17503 13.8973 4.63333 12.632 3.36802C11.3667 2.10271 9.82496
      1.4707 8 1.4707Z"
      fill="#E22B28"
    />
    <path
      d="M10.3945 4.81759C10.6585 4.55368 11.0866 4.55361 11.3505 4.81759C11.6144 5.08158 11.6144 5.50965 11.3505 5.77364L9.03999
      8.08419L11.1914 10.2356C11.4551 10.4995 11.4551 10.9277 11.1914 11.1916C10.9274 11.4556 10.4993 11.4554
      10.2353 11.1916L8.08394 9.04024L5.93257 11.1916C5.66858 11.4556 5.24053 11.4555 4.97652 11.1916C4.71251 10.9276 4.71253
      10.4996 4.97652 10.2356L7.12788 8.08419L4.81734 5.77364C4.55332 5.50963 4.55332 5.0816 4.81734 4.81759C5.08137 4.5538
      5.50945 4.55365 5.77339 4.81759L8.08394 7.12813L10.3945 4.81759Z"
      fill="#E22B28"
    />
  </svg>
);

export default SvgError;
